import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.5303 19.0303C10.2374 19.3232 9.76256 19.3232 9.46967 19.0303L3.21967 12.7803C2.92678 12.4874 2.92678 12.0126 3.21967 11.7197L9.46967 5.46967C9.76256 5.17678 10.2374 5.17678 10.5303 5.46967C10.8232 5.76256 10.8232 6.23744 10.5303 6.53033L5.56066 11.5H20C20.4142 11.5 20.75 11.8358 20.75 12.25C20.75 12.6642 20.4142 13 20 13H5.56066L10.5303 17.9697C10.8232 18.2626 10.8232 18.7374 10.5303 19.0303Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgArrowLeft;
